export default defineNuxtRouteMiddleware(async (to) => {
  devConsole.info("🛠️ Settings middleware", to.fullPath);

  const { guardFeatureRoute } = useSettingsGuard();

  const canUseSettingsFeature = await guardFeatureRoute(to);

  if (!canUseSettingsFeature.ok) {
    return canUseSettingsFeature.result;
  }
});
